module.exports = "/assets/02bc9ec284e3409c1903c8465aefe1eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SG.png
// module id = 2941
// module chunks = 0